import { createMuiTheme } from "@material-ui/core/styles"
import { defaultsDeep } from "lodash"
// import mainTheme from "./main"
import crewMamaTheme from "./crewmamaTheme"
const defaultTheme =
  // window.location.host.indexOf("adesk") === -1 ? crewMamaTheme : mainTheme
  crewMamaTheme

export const pickersTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: defaultTheme.palette.primary.light,
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: defaultTheme.palette.primary.light,
        // color: "black"
        "&:hover": {
          backgroundColor: "gray",
        },
      },
    },
  },
})

export default createMuiTheme(
  defaultsDeep(
    {
      palette: {
        error: {
          main: "#F04031",
        },
        success: {
          main: "#41B25B",
        },
      },
      typography: {
        textAlign: "left",
        h1: {
          fontFamily: ["Oswald", "sans-serif"].join(","),
          fontSize: "1.625rem", //26px
          fontWeight: 800,
        },
        h2: {
          fontSize: "1.25rem", //20px
          fontWeight: 700,
          fontFamily: ["Helvetica", "sans-serif"].join(","),
        },
        h3: {
          fontSize: "1.125rem", //18px
          fontWeight: 600,
          fontFamily: ["Helvetica", "sans-serif"].join(","),
        },
        h4: {
          fontSize: "1rem", //16px
          fontWeight: 600,
          fontFamily: ["Helvetica", "sans-serif"].join(","),
        },
        h5: {
          fontSize: "0.875rem", //14px
          fontWeight: 600,
          fontFamily: ["Helvetica", "sans-serif"].join(","),
        },
        // h6: {
        //   fontSize: "0.8125rem", //13px
        //   fontWeight: 600,
        // },
        // subtitles are gray font
        subtitle1: {
          color: "#9A9A9A",
          fontSize: "1rem", //16px
          lineHeight: 1.25,
          fontFamily: ["Helvetica", "sans-serif"].join(","),
        },
        subtitle2: {
          color: "#9A9A9A",
          fontSize: "1rem", //16px
          fontWeight: 700,
          lineHeight: 1.25,
          fontFamily: ["Helvetica", "sans-serif"].join(","),
        },
        body1: {
          fontSize: "0.875rem", //14px
          fontFamily: ["Helvetica", "sans-serif"].join(","),
        },
        body2: {
          fontSize: "0.75rem", //12px
          fontFamily: ["Helvetica", "sans-serif"].join(","),
        },
        button: {
          textTransform: "none",
          fontWeight: 700,
          fontSize: "1rem", //16px
          display: "flex",
          alignItems: "center",
          fontFamily: ["Helvetica", "sans-serif"].join(","),
        },
        //gray caption
        caption: {
          color: "#9A9A9A",
          fontSize: "0.6875rem", //11px
          fontFamily: ["Helvetica", "sans-serif"].join(","),
        },
      },
      overrides: {
        MuiButton: {
          label: {
            textTransform: "none",
          },
          root: {
            borderRadius: 20,
            boxShadow: "initial !important",
            "&$disabled": {
              opacity: "0.65",
            },
          },
          outlined: {
            borderRadius: 20,
            borderColor: "inherit",
          },
        },
        MuiCard: {
          root: {
            borderRadius: "26px",
            boxShadow:
              "0px 0px 0px -1px rgba(0, 0, 0, 0.1), 0px 2px 16px 0px rgba(0, 0, 0, 0.1), 0px 0px 2px 0px rgba(0, 0, 0, 0.1)",
          },
        },
        MuiDialog: {
          paper: {
            borderRadius: "26px",
          },
        },
        MuiDialogTitle: {
          root: {
            padding: "20px 24px",
          },
        },
        MuiDialogContent: {
          root: {
            padding: "0 24px",
          },
        },
        MuiDialogActions: {
          root: {
            padding: "20px 24px",
          },
        },
      },
    },
    defaultTheme
  )
)
